import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4c7d6c61")

_pushScopeId("data-v-4c7d6c61")
const _hoisted_1 = { class: "bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative" }
const _hoisted_2 = { class: "flex flex-1 justify-between gap-x-4 py-4" }
const _hoisted_3 = { class: "flex flex-grow" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Search = _resolveComponent("Search")!
  const _component_DropdownFilter = _resolveComponent("DropdownFilter")!
  const _component_BalanceRangeFilter = _resolveComponent("BalanceRangeFilter")!
  const _component_TimeRangePicker = _resolveComponent("TimeRangePicker")!
  const _component_Header = _resolveComponent("Header")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_TableV2 = _resolveComponent("TableV2")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Header, { class: "items-center" }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_Search, {
              class: "flex-1",
              value: _ctx.searchValue,
              onInput: _ctx.onSearchLastBalance,
              placeholder: _ctx.placeholderSearch,
              onClear: _ctx.onClearSearchLastBalance
            }, null, 8, ["value", "onInput", "placeholder", "onClear"])
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_DropdownFilter, {
              modelValue: _ctx.statusSaldo,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.statusSaldo = $event)),
              placeholder: "Status Saldo",
              dropdownTitle: "Status saldo",
              options: _ctx.statusOptions,
              iconLeft: "ics_o_wallet",
              onChange: _ctx.onApplyStatusFilter
            }, null, 8, ["modelValue", "options", "onChange"])
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_BalanceRangeFilter, {
              min: _ctx.minBalance,
              max: _ctx.maxBalance,
              onApply: _ctx.onApplyBalanceRange,
              onReset: _ctx.onResetBalanceRange
            }, null, 8, ["min", "max", "onApply", "onReset"])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_DropdownFilter, {
              modelValue: _ctx.sortSaldo,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.sortSaldo = $event)),
              placeholder: "Urutkan saldo",
              dropdownTitle: "Urutkan saldo",
              options: _ctx.sortOptions,
              iconLeft: "sort-filter",
              onChange: _ctx.onApplySortFilter
            }, null, 8, ["modelValue", "options", "onChange"])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_TimeRangePicker, {
              class: "mr-4 last-balance-calendar",
              onSelect: _ctx.setPeriode,
              isCloseDateAfterSelect: "",
              default: _ctx.$t('custom'),
              highlightOnSelected: true,
              customCalendar: true,
              advanceStyle: {
              width: '550px',
              fontSize: 'text-sm',
              fontWeight: 'font-medium'
            },
              customTotalMaxDate: 30,
              resetLimitOnSetOption: "",
              leftPosition: false,
              maxDate: new Date(),
              isSetMaxDate: ""
            }, null, 8, ["onSelect", "default", "maxDate"])
          ])
        ])
      ]),
      _: 1
    }),
    (
        _ctx.firstRequest &&
          _ctx.lastBalanceList.data.length === 0 &&
          !_ctx.isLoading &&
          !_ctx.isError
      )
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 0,
          "error-title": "Tidak Ada Saldo Terakhir",
          "error-image": "noData_empty",
          "error-message": "POS atau Klien masih belum melakukan top up saldo"
        }))
      : (_ctx.lastBalanceList.data.length === 0 && !_ctx.isLoading && !_ctx.isError)
        ? (_openBlock(), _createBlock(_component_ErrorMessage, {
            key: 1,
            "error-title": "Tidak Ada Saldo Terakhir",
            "error-image": "data-not-found",
            "error-message": "POS atau Klien masih belum melakukan top up saldo"
          }))
        : (_openBlock(), _createBlock(_component_TableV2, {
            key: 2,
            onRequest: _ctx.fetchLastBalanceList,
            pagination: _ctx.lastBalanceList.pagination,
            "onUpdate:pagination": _cache[3] || (_cache[3] = ($event: any) => (_ctx.lastBalanceList.pagination = $event)),
            loading: _ctx.isLoading,
            columns: _ctx.columns,
            data: _ctx.lastBalanceList.data,
            class: "my-2",
            errorCause: _ctx.errorCause,
            paginationStyle: "v3",
            borderBottom: false,
            customClassPagination: 'absolute w-full bottom-0 -mb-4 bg-white',
            isSpaceBottom: ""
          }, null, 8, ["onRequest", "pagination", "loading", "columns", "data", "errorCause"]))
  ]))
})